import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const PermissionsDomainName_EHREmulatorUI = 'EHR Emulator UI';
export const PermissionKeys_EHREmulatorUI = generateKeyNamesByAccessLevel(PermissionsDomainName_EHREmulatorUI, defaultUIAccessLevels);
//# sourceMappingURL=ui.js.map